// GtHealth.js — the health pieces shared by the Insights email and Auto outreach overviews (C1-NEWS2, C1-OB3).
// A tick, cross or warning per check; a rate judged against the lines mailbox providers use; a row of bars.
const nf = (n) => Number(n || 0).toLocaleString('en-GB');
const plural = (n, one, many) => nf(n) + ' ' + (n === 1 ? one : many);
export const pct = (a, b) => (b ? (a / b) * 100 : 0);
export const pctText = (a, b) => { if (!b) return '—'; const v = pct(a, b); return (v > 0 && v < 1 ? v.toFixed(1) : Math.round(v)) + '%'; };

// Healthy, worth a look, or a problem.
export const LIMITS = {
  bounce: { good: 2, bad: 5, note: 'Keep under 2%' },
  spam: { good: 0.1, bad: 0.3, note: "Gmail's limit is 0.3%. Aim under 0.1%" },
  unsub: { good: 0.5, bad: 1, note: 'Under 0.5% is healthy' },
  unsub_cold: { good: 1, bad: 2, note: 'Under 1% is healthy for first emails' },
};
export const bandOf = (k, v) => (v < LIMITS[k].good ? 'good' : v < LIMITS[k].bad ? 'watch' : 'bad');
export const BAND_WORD = { good: 'Healthy', watch: 'Worth a look', bad: 'Too high' };

export const Tick = ({ state }) => (
  <span className={'gtne-st gtne-st--' + state} aria-hidden="true">
    {state === 'ok' ? <svg viewBox="0 0 16 16" width="12" height="12"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      : state === 'bad' ? <svg viewBox="0 0 16 16" width="12" height="12"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /></svg>
        : <svg viewBox="0 0 16 16" width="12" height="12"><path d="M8 4v5M8 11.5v.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /></svg>}
  </span>
);

export function Metric({ k, label, n, of, who }) {
  const v = pct(n, of);
  const b = of ? bandOf(k, v) : null;
  return (
    <div className={'gtne-metric' + (b ? ' gtne-metric--' + b : '')}>
      <em>{label}</em>
      <b>{of ? pctText(n, of) : '—'}</b>
      <span>{of ? <><i className={'gtne-band gtne-band--' + b}>{BAND_WORD[b]}</i>{plural(n, who ? who[0] : 'person', who ? who[1] : 'people')} · {LIMITS[k].note}</> : 'Nothing sent in the last 30 days'}</span>
    </div>
  );
}

// rows: [label, value, sub (shown beside the number), soft (paler bar)]; bars are against the first row.
export function Bars({ rows, note, onRow }) {
  const base = (rows[0] && rows[0][1]) || 0;
  return (
    <div className="gtne-funnel">
      {rows.map(([l, v, sub, soft, key]) => {
        const inner = <>
          <span className="gtne-fn-l">{l}</span>
          <span className="gtne-fn-bar"><i style={{ width: Math.max(base ? pct(v, base) : 0, v ? 1.5 : 0) + '%' }} /></span>
          <span className="gtne-fn-n"><b>{nf(v)}</b>{sub ? <em>{sub}</em> : null}</span>
        </>;
        return onRow && key
          ? <button key={l} type="button" className={'gtne-fn gtne-fn--btn' + (soft ? ' gtne-fn--soft' : '')} onClick={() => onRow(key)}>{inner}</button>
          : <div key={l} className={'gtne-fn' + (soft ? ' gtne-fn--soft' : '')}>{inner}</div>;
      })}
      {note && <p className="gtne-fn-note">{note}</p>}
    </div>
  );
}
